<template>
  <v-list>
    <v-list-item
      v-for="item in portals"
      :key="item.name"
      link
    >
      <v-list-item-title
        v-text="item.name"
        @click="openGooglePortalSearch(item.phrase)"
      ></v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "ToolGoogleBrowserSearch",
  props: ["facility"],
  data: () => ({
    loading: false,
  }),
  components: {},
  computed: {
    portals() {
      return [
        {
          name: "google.com",
          phrase: `${this.facility.name} ${this.facility.facility.address}`,
        },
        {
          name: "booking.com",
          phrase: `${this.facility.name} ${this.facility.facility.address} site:booking.com`,
        },
        {
          name: "expedia.com",
          phrase: `${this.facility.name} ${this.facility.facility.address} site:www.expedia.com`,
        },
        {
          name: "airbnb.pl",
          phrase: `${this.facility.name} ${
            this.facility.facility.cities.length > 0
              ? this.facility.facility.cities[0].city.name
              : ""
          }  site:www.airbnb.pl`,
        },
        {
          name: "noclegi.pl",
          phrase: `${this.facility.name} ${this.facility.facility.address} site:noclegi.pl`,
        },
        {
          name: "nocowanie.pl",
          phrase: `${this.facility.name} ${this.facility.facility.address} site:nocowanie.pl`,
        },
        {
          name: "facebook",
          phrase: `${this.facility.name} ${this.facility.facility.address} site:facebook.com`,
        },
        {
          name: "wszystkie",
          phrase: `*`,
        },
      ];
    },
  },
  mounted() {},
  methods: {
    openGooglePortalSearch(phrase) {
      if (phrase === "*") {
        this.openAllGooglePortalSearch();
      } else {
        window.open(
          `https://www.google.pl/search?ie=utf-8&oe=utf-8&q=${phrase}`
        );
      }
    },
    openAllGooglePortalSearch() {
      this.portals.forEach((item) => {
        if (item.phrase !== "*") {
          this.openGooglePortalSearch(item.phrase);
        }
      });
    },
  },
  watch: {},
};
</script>
